import { passwordStrength } from 'check-password-strength'
import type { FormKitNode } from '@formkit/core'

const pwd = (node: FormKitNode) => {
  if (!node) return false
  const value = node?.value as string
  if (
    !value ||
    passwordStrength(value).value === 'Too weak' ||
    passwordStrength(value).value === 'Weak'
  ) {
    return false
  } else {
    return true
  }
}

export { pwd }
